export enum LogaltyResponseStatus {
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Error = 'ERROR',
}
